module.exports = __webpack_public_path__ + "static/media/preview_screen2.ccaae58a.png";